import {
  LandingParameters,
  ParameterKey,
  ParameterValue
} from '@anm/api/modules/hosting';
import isEqual from 'lodash/fp/isEqual';
import omitBy from 'lodash/fp/omitBy';

export const canUpdateParams = (
  key: ParameterKey,
  params: ParameterValue,
  parameters?: LandingParameters
) => {
  if (!parameters) return true;

  const prevParams =
    key === 'cta'
      ? omitBy((_: string, k: string) => k === 'disabled')(parameters[key])
      : parameters[key];

  return !isEqual(prevParams, params);
};
